import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, of, shareReplay } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TooltipService {
  private tooltipContent: { [key: string]: string } = {};
  private loadTooltips$: Observable<{ [key: string]: string }>;
  private isLoaded: boolean = false;

  constructor(private http: HttpClient) {
    this.loadTooltips$ = this.http.get<{ [key: string]: string }>('tooltips.json').pipe(
      map(content => {
        this.tooltipContent = content;
        this.isLoaded = true;
        return content;
      }),
      catchError((error) => {
        console.error('Failed to load tooltips:', error);
        this.isLoaded = true; // Mark as loaded to avoid blocking
        return of({});
      }),
      shareReplay(1)
    );

    // Trigger the HTTP request immediately
    this.loadTooltips$.subscribe();
  }

  getTooltipContent(key: string): string {
    return this.tooltipContent[key] || (this.isLoaded ? 'No tooltip available' : 'Loading...');
  }

  // Optional: Expose observable for components that need to wait for tooltip data
  getTooltipsObservable(): Observable<{ [key: string]: string }> {
    return this.loadTooltips$;
  }

  isTooltipsLoaded(): boolean {
    return this.isLoaded;
  }
}
